// extracted by mini-css-extract-plugin
export default {"Wrapper":"ContractDocumentsView_Wrapper__CI-uM"};